<template>
	<div class="access-denied">
		<div class="access-denied__text">
			<div class="access-denied__primary-text">
				{{ title }}
			</div>
			<div class="access-denied__secondary-text">
				{{ subtitle }}
			</div>
		</div>
		<img
			class="access-denied__graphic"
			:src="accessDenied"
			alt="Stop barricade graphic for denied access"
		/>
		<footer class="access-denied__actions">
			<slot name="action">
				<ButtonClassic
					variant="primary"
					:labelText="btnText"
					@click="onBtnClick"
				/>
			</slot>
		</footer>
	</div>
</template>

<script>
import pageMixin from '@/mixins/page-mixin';
import ButtonClassic from '@/components/forms/button/button-classic.vue';
import AccessDenied from '@/assets/403.svg';

export default {
	name: 'AccessDenied',
	components: {
		ButtonClassic
	},
	data() {
		return {
			accessDenied: AccessDenied
		};
	},
	mixins: [pageMixin],
	created() {
		this.hidePageLoader();
	},
	props: {
		title: {
			type: String,
			default: "We're Sorry. 403 Access Denied"
		},
		subtitle: {
			type: String,
			default: 'Let’s try another route and get you on your way.'
		},
		btnText: {
			type: String,
			default: 'Go to Previous Page'
		},
		btnRoute: {
			type: String,
			default: 'dashboard'
		},
		fromIframe: {
			type: Boolean,
			default: false
		},
		fromUrl: {
			type: String
		}
	},
	methods: {
		onBtnClick() {
			top.location.assign(this.fromUrl);
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * No results found
    * Can use SCSS variables = TRUE
*/

.access-denied {
	@include transform-full-center;
	top: 30%;
	max-width: 420px;
	text-align: center;
	color: var(--bg-0-fg-4);
}

@include error-msg('access-denied');
.access-denied {
	flex-direction: column;
	margin-top: 0;
	gap: $gutter-xxl;

	&__text {
		align-items: center;
	}

	&__graphic {
		width: 245px;
	}

	&__secondary-text {
		width: 216px;
	}
}
</style>
